import { useContext, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Accordion, BoxFull, Button, TransactionalSubheader } from "iuvity-ui-components";
import { Header } from "../../components";
import { IMDataTableActions } from "../../components/iuvimarketing/IMDatableActions";
import {
  CustomDialog,
  DialogProps,
} from "../../components/dialog/CustomDialog";
import { AppContext } from "../../context";
import { CustomFormComponent } from "../../components/shared/CustomFormComponent";
import { infoCampaignsFields } from "../../constants";
import { IMGeneralInfoFormSchema } from "../../validations/schemas";
import { useConfigurations } from "../../hooks/useConfigurations";
import { convertValueTypes } from "../../utils";
import { useForm } from "react-hook-form";
import { PrivilegeValidatorComponent } from "../../components/shared/PrivilegeValidatorComponent";

export const IuviMarketingAdminPage = () => {
  const navigate = useNavigate();
  const {
    t,
    appState: { user, permissiondInfoByRole},
  } = useContext(AppContext);

  const { data, configurationAction } = useConfigurations("DATA");

  const form = useForm({
    mode: "onChange",
    delayError: 1200,
    reValidateMode: "onChange",
  });

  const {
    getValues,
    reset,
    formState: { dirtyFields, isDirty, isValid },
  } = form;

  const [modalProps, setModalProps] = useState<DialogProps>({
    visible: false,
  } as DialogProps);

  const onSave = async () => {
    const formValues = getValues();
    const dirtyFieldsKeys: any[] = Object.keys(dirtyFields);

    if (data && dirtyFieldsKeys.length > 0) {
      const newValues = dirtyFieldsKeys.map((key) => {
        const keyInfo = data.find(
          (prop: any) => prop.key.split(".").pop() === key
        );
        return {
          id: keyInfo!.id,
          key: keyInfo!.key,
          value: `${formValues[key]}`,
          updatedby: user?.name,
        };
      });
      await configurationAction("UPDATE", newValues);
    }
    reset(formValues);
  };

  const onReturn = () => {
    navigate(-1);
    window.scrollTo(0, 0);
  };

  const onCancel = () => {
    navigate("/configurations/iuvimarketing");
    window.scrollTo(0, 0);
    reset();
  };

  const handleModalProps = (isCancelButton?: boolean) => {
    setModalProps((prev) => ({
      ...prev,
      visible: true,
      title: isCancelButton
        ? t("IuviMarketing.cancelModalTitle")
        : t("IuviMarketing.saveModalTitle"),
      content: isCancelButton
        ? t("IuviMarketing.cancelModalContent")
        : t("IuviMarketing.saveModalContent"),
      onConfirm: isCancelButton ? onCancel : onSave,
    }));
  };

  useEffect(() => {
    if (data && data.length > 0) {
      const initialValues = data
        ?.map((property: any) => {
          const valKey = property.key.split(".").pop() || "";
          return {
            [valKey]: convertValueTypes(property.value),
          };
        })
        .reduce((acc: any, current: any) => ({
          ...acc,
          ...current,
        }));
      reset(initialValues);
    }
  }, [data, reset]);

  return (
    <>
      {/* <Header
        welcomeMessage={t("Dashboard.welcomeTitle")}
        userName={user?.name}
      /> */}

      <TransactionalSubheader
        subheaderTitle={
          <div style={{ position: "relative", left: "-40px" }}>
          {t("IuviMarketing.iuviMarketingTitle")}
          </div>
        }
      >
        <TransactionalSubheader.BreadCrumb
          id={t("IuviMarketing.iuviMarketingTitle")}
          disabledDefaultHome={true}
          breadcrumbsHomeItem={{
            icon: "iu iu-icon-home",
            command: () => navigate("/"),
          }}
          breadcrumbsItems={[
            {
              label: t("IuviMarketing.iuviMarketingTitle"),
              style: { fontWeight: "bold" },
              disabled: true
            },
          ]}
        />
        <TransactionalSubheader.Title />
        <div className="t-subheader-content">
          <span>{t("IuviMarketing.iuviMarketingDescription")}</span>
        </div>
      </TransactionalSubheader>

      {data && 
        <>
          <CustomFormComponent 
            functionality="IuviMarketing"
            fields={infoCampaignsFields}
            form={form}
            schemaOfValidation={IMGeneralInfoFormSchema}
          />

          <BoxFull className="pt-0 px-4 pb-5" style={{ backgroundColor: "transparent" }}>
            <div className="flex align-items-center justify-content-end gap-5">
              <Button
                variant="p-button-link"
                label={t("IuviMarketing.cancelBtnLabel")}
                onClick={!isDirty ? onReturn : () => handleModalProps(true)}
              />
              <PrivilegeValidatorComponent showButton={permissiondInfoByRole.UPDATE} >
                <Button
                  variant="p-button"
                  label={t("Products.saveBtnLabel")}
                  disabled={!(isValid && isDirty)}
                  onClick={() => handleModalProps()}
                />
              </PrivilegeValidatorComponent>
            </div>
          </BoxFull>

          <BoxFull className="pt-0" variant="tertiary">
            <Accordion
              activeIndex={0}
              id="accordion"
              items={[
                {
                  children: (
                    <IMDataTableActions auxModalController={setModalProps} />
                  ),
                  disabled: false,
                  header: t("IuviMarketing.marketingCampaingsLabel"),
                  key: "112233",
                },
              ]}
            />
          </BoxFull>
        </>
      }

      <CustomDialog
        title={modalProps.title}
        visible={modalProps.visible}
        content={modalProps.content}
        handleModalState={setModalProps}
        onConfirm={modalProps.onConfirm}
      />
    </>
  );
};
